import { useCallback, useMemo } from 'react';
import { useSnapshot } from 'valtio';

import { useWizardOptional, useWizardsAllowed } from '@cartwhl/ui/wizard';

import { projectStore, uiStore, userStore } from 'stores';

import {
  canvasOnOpenWizard,
  formatCanvasExportDestination,
  getCanvasOnMotionWizard,
  motionProjectHasTimelineClips,
} from './canvasWizards';

export function useStartCanvasTour() {
  const wizard = useWizardOptional();
  const wizardsAllowed = useWizardsAllowed();
  const { userInfo } = useSnapshot(userStore.state);
  const { currentProject } = useSnapshot(projectStore.state);

  const onMotionWizard = useMemo(
    () =>
      getCanvasOnMotionWizard(
        formatCanvasExportDestination(userInfo.productFocus),
      ),
    [userInfo.productFocus],
  );

  const canShowTour = Boolean(wizard) && wizardsAllowed;

  const startCanvasTour = useCallback(() => {
    if (!wizard || !wizardsAllowed) {
      return;
    }

    const hasTimelineClips = motionProjectHasTimelineClips(currentProject.data);
    if (!hasTimelineClips) {
      uiStore.setMotionFrontDoorMode('video');
      wizard.startWizard(canvasOnOpenWizard);
      return;
    }

    wizard.startWizard(onMotionWizard);
  }, [wizard, wizardsAllowed, currentProject.data, onMotionWizard]);

  return { canShowTour, startCanvasTour };
}
